export default {
  transaction: {
    title: 'รายการธุรกรรม',
    select: 'เลือก',
    all: 'ทั้งหมด',
    loading: 'กำลังโหลด...',
    noMoreData: 'ไม่มีข้อมูลเพิ่มเติม',
    mockSuccess: 'จำลองสำเร็จ',
    mockFail: 'จำลองล้มเหลว',
    mockSuccessDone: 'จำลองสำเร็จเรียบร้อย',
    mockFailDone: 'จำลองล้มเหลวเรียบร้อย',
    mockFailed: 'การจำลองล้มเหลว',
    today: 'วันนี้',
    yesterday: 'เมื่อวาน',
    last3Days: '3 วันล่าสุด',
    last7Days: '7 วันล่าสุด',
    last15Days: '15 วันล่าสุด',
    last30Days: '30 วันล่าสุด',
    allTypes: 'ทุกประเภท',
    deposit: 'ฝากเงิน',
    withdrawal: 'ถอนเงิน',
    withdrawalRefund: 'คืนเงินการถอน',
    bet: 'เดิมพัน',
    win: 'ชนะ',
    manualAdd: 'เพิ่มด้วยตนเอง',
    manualSubtract: 'หักด้วยตนเอง',
    commission: 'ค่าคอมมิชชั่น',
    bonus: 'โบนัส',
    vipUpgradeReward: 'รางวัลอัปเกรด VIP',
    vipSalary: 'เงินเดือน VIP',
    gameOutPrincipal: 'ออกจากเกม - เงินต้น',
    gameOutBonus: 'ออกจากเกม - โบนัส',
    bonusTransferOut: 'โอนโบนัสออก',
    allStats: 'ทุกสถานะ',
    underReview: 'อยู่ระหว่างตรวจสอบ',
    pendingPayout: 'รอจ่ายเงิน',
    successful: 'สำเร็จ',
    failed: 'ไม่สำเร็จ',
    cancelled: 'ยกเลิก',
    processing: 'กำลังดำเนินการ',
  },
};
